import { Component, OnInit } from '@angular/core';
import { BaseDataService, BaseUpdateComponent, ConfirmationDialogButtons, ModalService, NotificationService } from 'yt-ng-framework';
import { InstrukcijaPlacanja } from './instrukcija-placanja';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import * as var_config from '../../../var_config';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-instrukcija-placanja-update',
  templateUrl: './instrukcija-placanja-update.component.html'
})
export class InstrukcijaPlacanjaUpdateComponent extends BaseUpdateComponent<InstrukcijaPlacanja> implements OnInit {
  varConfig=var_config;

  constructor(
      protected activatedRoute: ActivatedRoute,
      protected baseDataService: BaseDataService,
      // protected notificationsService: NotificationsService,
      protected toastrService: NotificationService,
      protected translateService: TranslateService,
      protected modalService: ModalService
    ) {
      super(activatedRoute, baseDataService, toastrService, translateService, modalService);
      }
    

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Intermediary', Validators.required, 'required', 'INSTRUKCIJAPLACANJA.INTERMEDIARY.VALIDATION.REQUIRED');
    this.IDProcessed
      .subscribe((value) => {
        this.saveDisabled = false;
        this.resetDisabled = false;
        let devizni: boolean = false;
        if (this.Parameters && this.Parameters.get(0))
          devizni = Boolean(this.Parameters.get(0).get(0).Value);
        if (value && this.Item.ID == -1) {

          if (!devizni)
            this.translateService.get(["INSTRUKCIJAPLACANJA.DINARSKI.MESSAGE", "INSTRUKCIJAPLACANJA.SINGULAR"])
              .subscribe(translate => {
                this.modalService.ShowConfirmationDialog(translate["INSTRUKCIJAPLACANJA.SINGULAR"], translate["INSTRUKCIJAPLACANJA.DINARSKI.MESSAGE"], "warning", ConfirmationDialogButtons.Ok);
                this.ResetValues(true, false);
              });
        }
        else {
          if (!devizni) {
            this.saveDisabled = true;
            this.resetDisabled = true;
          }
        }
      })
  }

}
